import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import axios from "axios";
import moment from "moment";
import { AuctionCard } from "../AuctionCard";

class EventsWidget extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
            data: [],
            isLoading: true
        };

        this.fetchData = this.fetchData.bind(this);
    }
    fetchData(){
        let query = "?";

        if(this.props.filterGroups && (this.props.filterGroups instanceof Array)){
            query += `filterGroups=${JSON.stringify(this.props.filterGroups)}&`;
        }

        if(this.props.sortOrders && (this.props.sortOrders instanceof Array)){
            query += `sortOrders=${JSON.stringify(this.props.sortOrders)}&`;
        }

        if(this.props.pageSize && (typeof this.props.pageSize == "number") && this.props.pageCount && (typeof this.props.pageCount == "number")){
            query += `pageSize=${this.props.pageSize * this.props.pageCount}&`;
        }

        axios.get(`/api/events${query}`)
            .then((eventResults)=>{
                this.setState({
                    data: eventResults.data.data || [],
                    isLoading: false
                });
            }).catch((err)=>{
                console.error(err);
                this.setState({
                    isLoading: false
                });
            });
    }
    componentDidMount(){
        this.fetchData();
    }
    render(){
        if(this.state.data && this.state.data.length > 0){
            return(
                <div className="events-widget">
                    {this.props.title && (
                        <h2 className="title">{this.props.title}</h2>
                    )}
                    <div className="EventGrid">
                        {this.state.data.map(({
                            url_key,
                            title,
                            event_image,
                            start_date_time,
                            end_date_time
                        }) => (
                            <AuctionCard
                                key={url_key}
                                title={title}
                                image={`${localStorage.restUrl}/pub/media/event/${event_image}`}
                                link={url_key}
                                startDate={moment(start_date_time).format("DD MMM YYYY")}
                                endDate={start_date_time == end_date_time ? "" : moment(end_date_time).format("DD MMM YYYY")}
                            />
                        ))}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

EventsWidget.defaultProps = {
    template: "grid",
    pageSize: 4,
    pageCount: 3,
    pageScroll: 4,
    autoPlay: false,
    autoPlayInterval: 3000,
    speed: 500,
    loop: true
};

EventsWidget.propTypes = {
    title: PropTypes.string,
    filterGroups: PropTypes.array,
    sortOrders: PropTypes.array,
    pageSize: PropTypes.number,
    pageCount: PropTypes.number,
    pageScroll: PropTypes.number,
    autoPlay: PropTypes.bool,
    autoPlayInterval: PropTypes.number,
    speed: PropTypes.number,
    loop: PropTypes.bool,
    template: PropTypes.string
};

export {EventsWidget};
